// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './lang'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'

import 'normalize.css/normalize.css'
import 'font-awesome/css/font-awesome.min.css'
import 'viewerjs/dist/viewer.css' // 图片预览插件样式
import 'babel-polyfill' // 解决ie浏览器兼容问题
import './components/SvgIcon/index.js'
import './styles/index.scss'
import './utils/format/date'
import './utils/format/double'
import './utils/global/function/index' // 引入全部方法
import './utils/global/component/index' // 引入全局组件
import './permission' // 前台权限拦截
import '@/utils/directive'
import '@/assets/icon/iconfont.css'

import Meta from 'vue-meta' // meta信息管理
import Viewer from 'v-viewer' // 图片预览插件
import animated from 'animate.css' // 引入animate.css库
import {deepClone} from '@/utils'
import Direction from '@/utils/direction/index' // 引入方向键切换焦点
import jm from 'vue-jsmind'
Vue.use(jm)
if (window.jsMind) {
  Vue.prototype.jsMind = window.jsMind
}
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Direction)

Vue.use(Meta)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    fullscreen: true,
    url: 'data-source'
  }
})
Vue.use(animated)

window.initState = deepClone(store.state)
/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js